import React, { Component } from 'react';
import Chip from 'material-ui/Chip';
import ActionToday from 'material-ui/svg-icons/action/today';
import ActionHistory from 'material-ui/svg-icons/action/history';
import ActionList from 'material-ui/svg-icons/action/list';
import ActionThumbUp from 'material-ui/svg-icons/action/thumb-up';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import SocialPlusOne from 'material-ui/svg-icons/social/plus-one';
import SocialGroup from 'material-ui/svg-icons/social/group';
import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';
import {List, ListItem} from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import CommunicationChatBubbleOutline from 'material-ui/svg-icons/communication/chat-bubble-outline';

import Common from './Common';

class ModeToolbar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mode: 'daily',
      dialogOpen: false,
      authorList: [],
      menuOpen: false,
      feedbackError: false,
      feedbackDialogOpen: false,
      thankDialogOpen: false,
    }
    this.feedbackText = '';
    this.props.parent.modeToolbar = this;
  }

  changeMode(mode) {
    this.props.parent.mainToolbar.clearSearch(true);
    this.props.parent.actionSearch('', mode);
  }

  setMode(mode) {
    this.setState({
      mode: mode
    });
  }

  openDialog() {
    this.setState({
      authorList: JSON.parse(JSON.stringify(this.props.parent.mainToolbar.authorList)),
      dialogOpen: true,
      menuOpen: false
    });
  }

  handleDialogClose() {
    this.setState({
      dialogOpen: false
    });
  }

  openThankDialog() {
    this.setState({
      menuOpen:false,
      thankDialogOpen: true
    });
  }

  handleThankDialogClose() {
    this.setState({
      thankDialogOpen: false
    });
  }

  selectLP(title){
    this.props.parent.mainToolbar.handleUpdateInput(title);
    this.setState({
      dialogOpen: false
    });
  }

  menuHandleRequestClose() {
    this.setState({
      menuOpen:false
    });
  }

  onTouchOpenMenu(event) {
    this.setState({
      menuOpen:true,
      menuAnchorEl: event.currentTarget
    });
  }

  selectLikeMode() {
    Common.getTempToken().then((token) => {
      this.props.parent.actionSearch('', 'like', false, { token:token });
    });
    this.menuHandleRequestClose();
  }

  selectHistoryMode() {
    Common.getTempToken().then((token) => {
      this.props.parent.actionSearch('', 'history', false, { token:token });
    });
    this.menuHandleRequestClose();
  }

  handleSendFeedback() {
    if (this.feedbackText === '' || !this.feedbackText) {
      this.setState({feedbackError: true});
    }
    else {
      var payload = {};
      payload.topic = 'sendMessage';
      payload.message = this.feedbackText;
      Common.sendPayloadMessage(payload).then(() => {
        console.log('alread send feedback');
      });
      this.handleFeedbackDialogClose();
      this.props.parent.showSnackMessage('ขอบคุณมากๆ เลยครับสำหรับข้อเสนอแนะ')
    }
  }

  openFeedbackDialog(){
    this.setState({
      menuOpen:false,
      feedbackDialogOpen: true
    });
  }

  handleFeedbackDialogClose() {
    this.feedbackText = '';
    this.setState({
      feedbackDialogOpen: false,
      feedbackError: false
    });
  }

  handleUpdateFeedbackInput(event, value) {
    this.feedbackText = value;
  }

  selThankLink(link) {
    this.handleThankDialogClose();
    window.open(link);
  }

  render() {
    if (!localStorage.getItem("lang")) {
      return (<div></div>);
    }
    var selMenu = Common.getTitleList();
    var dhammaTopic = selMenu.modeTitleW;
    var widthChip = 376;
    var self = this;

    if (localStorage.getItem("lang") === 'EN') {
      widthChip = 412;
    }

    var dialog = function() {
      const actions = [
        <FlatButton
          label={selMenu.cancel}
          labelStyle={{color:'#888888'}}
          onClick={self.handleFeedbackDialogClose.bind(self)}
        />,
        <FlatButton
          label={selMenu.modeSendButton}
          labelStyle={{color:'#2196F3'}}
          onClick={self.handleSendFeedback.bind(self)}
        />,
      ];

      return (
        <Dialog
            title={selMenu.feedback}
            modal={false}
            open={self.state.feedbackDialogOpen}
            onRequestClose={self.handleFeedbackDialogClose.bind(self)}
            autoScrollBodyContent={true}
            actions={actions}
        >
        <span style={{color:'#888888'}}>{selMenu.feedbackDesc}</span>
        <br /><br />
        <TextField
          hintText={selMenu.feedbackHint}
          multiLine={true}
          fullWidth={true}
          onChange={self.handleUpdateFeedbackInput.bind(self)}
          errorText={self.state.feedbackError ? selMenu.feedbackValidate : null }
          underlineStyle={{borderColor:'#2196F3'}}
          underlineFocusStyle={{borderColor:'#2196F3'}}
        />
        </Dialog>
      )
    }

    if (Common.isMobile()) {
      dhammaTopic = selMenu.modeTitleM;
      widthChip = 306;
      if (localStorage.getItem("lang") === 'EN') {
        widthChip = 290;
      }
      var phoneSize = window.innerWidth;
      if (phoneSize < widthChip) {
        widthChip = phoneSize;
      }
    }

    return (
      <div>
      <table style={{marginTop:2, width:'100%'}}>
        <tbody>
          <tr>
          <td></td>
          <td style={{width:widthChip}}>
            <div style={{display: 'flex',flexWrap: 'wrap'}}>
              <Chip labelColor="#535353" style={{margin:2, boxShadow: '1px 1px 1px #dddddd', cursor: 'pointer'}} backgroundColor="#FFFFFF" onClick={this.changeMode.bind(this, 'daily')}>
                <Avatar icon={<ActionToday />} color="#FFFFFF"  backgroundColor={this.state.mode === 'daily' ? "#FF9800" : "#CCCCCC"} />
                {dhammaTopic[0]}
              </Chip>
              <Chip labelColor="#535353" style={{margin:2, boxShadow: '1px 1px 1px #dddddd', cursor: 'pointer'}} backgroundColor="#FFFFFF" onClick={this.changeMode.bind(this, 'popular')}>
                <Avatar icon={<SocialPlusOne />} color="#FFFFFF" backgroundColor={this.state.mode === 'popular' ? "#FF9800" : "#CCCCCC"} />
                {dhammaTopic[1]}
              </Chip>
              <Chip labelColor="#535353" style={{margin:2, boxShadow: '1px 1px 1px #dddddd', cursor: 'pointer'}} backgroundColor="#FFFFFF" onClick={this.onTouchOpenMenu.bind(this)}>
                <Avatar icon={<ActionList />} color="#FFFFFF" backgroundColor={(this.state.mode === 'person' || this.state.mode === 'history' || this.state.mode === 'like') ? "#FF9800" : "#CCCCCC"} />
                {dhammaTopic[2]}
              </Chip>
              </div>
          </td>
          <td></td>
          </tr></tbody>
      </table>

      <Dialog
          title={selMenu['selAjahn']}
          modal={false}
          open={this.state.dialogOpen}
          onRequestClose={this.handleDialogClose.bind(this)}
          autoScrollBodyContent={true}
        >
          <List>
            {
              this.state.authorList.map((obj, idx) => {
                var profileImage = process.env.PUBLIC_URL + obj.image;
                return (
                  <ListItem
                    key={idx}
                    primaryText={obj.title}
                    leftAvatar={<Avatar src={profileImage} />}
                    onClick={this.selectLP.bind(this, obj.title)}
                  />
                )
              })
            }
          </List>
      </Dialog>
      <Dialog
          title={selMenu['thankTitle']}
          modal={false}
          open={this.state.thankDialogOpen}
          onRequestClose={this.handleThankDialogClose.bind(this)}
          autoScrollBodyContent={true}
        >
          <List>
            {
              selMenu['thankList'].map((obj, idx) => {
                return (
                  <ListItem
                    key={idx}
                    primaryText={obj.title}
                    leftIcon={<ActionThumbUp />}
                    onClick={this.selThankLink.bind(this, obj.link)}
                  />
                )
              })
            }
          </List>
      </Dialog>
      <Popover
          open={this.state.menuOpen}
          anchorEl={this.state.menuAnchorEl}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={this.menuHandleRequestClose.bind(this)}
          style={{marginTop:3}}
       >
          <Menu>
            <MenuItem primaryText={selMenu['ajahn']} onClick={this.openDialog.bind(this)} leftIcon={<SocialGroup />} />
            <MenuItem primaryText={selMenu['history']} onClick={this.selectHistoryMode.bind(this)} leftIcon={<ActionHistory />}/>
            <MenuItem primaryText={selMenu['like']} onClick={this.selectLikeMode.bind(this)} leftIcon={<ActionFavoriteBorder />}/>
            <MenuItem primaryText={selMenu['feedback']} onClick={this.openFeedbackDialog.bind(this)} leftIcon={<CommunicationChatBubbleOutline />}/>
            <MenuItem primaryText={selMenu['thankTitle']} onClick={this.openThankDialog.bind(this)} leftIcon={<ActionThumbUp />}/>
          </Menu>
        </Popover>
        {dialog()}
      </div>
    );
  }
}

export default ModeToolbar;



// WEBPACK FOOTER //
// ./src/ModeToolbar.js